import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TrackingBox.css";
import bgImage from "../../assets/image1.png";

const TrackingBox = () => {
  const [awbInput, setAwbInput] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[ ,]+/g, "\n"); // space or comma → new line
    setAwbInput(value);
  };

  const handleTrack = () => {
    if (!awbInput.trim()) {
      alert("Please enter tracking number");
      return;
    }

    const awbArray = awbInput
      .split(/\n+/)
      .map((awb) => awb.trim())
      .filter(Boolean);

    navigate("/tracking-box", {
      state: { awbArray },
    });
  };

  return (
    <section
      className="contact-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="track-wrapper">
        <div className="track-card">
          <div className="track-tabs">
            <span className="active">Tracking Order</span>
          </div>

          <textarea
            className="awb-textarea"
            placeholder="Enter tracking numbers (one per line)"
            value={awbInput}
            onChange={handleChange}
          />

          <button onClick={handleTrack}>Track</button>

          <div className="track-footer">
            <span>Multiple Tracking Numbers Supported</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackingBox;
